module.exports = "/_next/static/images/ConsistentData@2x-7d9eb6a74d85096310a6eb77b0956e5c.png";